//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


	import {detailData} from '@/api/cmInvo/contInvoice';
	import {dateFormat} from '@/utils/common';
	import {previewFile} from '@/utils/common';
	//import {BASIC,JPT_URL} from "@/config/constant"

	export default {
		name:'invoListPage',
		data(){
	      return {
	      	flag:this.$route.params.flag,
	      	// 开票id
	      	mainId:this.$route.params.mainId,
	      	// 开票类型
	      	invoType:this.$route.params.invoType,
	      	// 公司名称
	      	comName:this.$route.params.comName,
	      	// 开票主表是数据
	      	invoFrom:{},
	      	// 合同数据
	      	contInfo:{},
	      	// 开票弹框
	      	allOpenFlag:false,
	      	partOpenFlag:false,
	      	// 排序
	      	sort: {
		       name: '',
		       order: 'asc'
		    },
	      	outSourceColumns:[
	          { title: '角色', width: 100, name: 'roleName' },
	          { title: '人天单价(含税)', name: 'unitPrice', width: 95, align: 'center', sortable: true },
	          { title: '人天', name: 'workDays', width: 90, align: 'center', sortable: true },
	          { title: '价税合计', name: 'amount', width: 95, align: 'center', sortable: true }
	      	],
	      	outSourceData:[],
	      }
		},
		created(){
			// 加载数据
			this.loadData();
		},
		computed:{

		},
		mounted: function(){
		},
		methods:{
			// 文件预览 下载
			preview(fileId){
				previewFile(fileId);
		        /*var url=JPT_URL+BASIC+"/doc/preview?docId="+fileId;
		        this.JX_download(url);*/
			},
		    // 下载最新版本
		    /*JX_download(url){
		      plus.nativeUI.showWaiting( "下载中..." );
		      //创建下载管理对象
		      var SX_down= plus.downloader.createDownload(url,{}, function ( d, status ) {
		        // 下载完成
		        if ( status == 200 ) {
		          plus.nativeUI.closeWaiting();
		          //下载成功后的回调函数
		          // plus.nativeUI.toast( "下载成功，准备安装" + d.filename );
		          plus.runtime.openFile( d.filename, {}, function ( e ) {//调用第三方应用打开文件
		            plus.nativeUI.toast('打开失败');
		          });

		        } else{
		          plus.nativeUI.closeWaiting();
		          plus.nativeUI.toast('下载失败');
		        }
		      });
		      SX_down.start();
		    },*/
			// 日期格式化
			dateFormatter(date){
				return dateFormat(date);
			},
			// 返回
			goback(){
				//this.$router.push({ name:'合同开票'});
        		this.$router.go(-1);
			},
		    // 加载数据
		    loadData(){
		        var condition = {'invoId':this.mainId,'flag':this.flag};
		        detailData(condition).then(response => {
		        	// 数据赋值
	          		this.invoFrom = response.invoRecordData;
	          		this.contInfo = response.contractData;
	          		this.outSourceData = response.outSourceData;
		        });
		    },
		    // 排序变化事件
		    handleSortChange ({name, order}) {
		      this.outSourceData = this.outSourceData.sort((a, b) => order === 'asc' ? a[name] - b[name] : b[name] - a[name]);
		    },
		    // 计算待开票的金额
		    calcToDoAmt(sumAmt,taxAmt){
		    	return parseFloat((sumAmt-taxAmt).toFixed(2));
		    },

		}
	}



// WEBPACK FOOTER //
// ./src/view/cmInvo/invo/invoDetailView.vue